import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import notification from './modules/notification'
import userReport from './modules/user-report'
import commentReport from './modules/comment-report'
import versionControl from './modules/version-control'
import incident from './modules/incident'
import incidentReport from './modules/incident-report'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    notification,
    userReport,
    commentReport,
    versionControl,
    incident,
    incidentReport
  },
  state: {
    controls: {
      showDrawer: true
    }
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    }
  }
})
